export const formatedPhoneNumber = (phoneNumber: string | undefined) => {
  return phoneNumber
    ? `${phoneNumber.substring(0, 4)} ${phoneNumber.substring(
        4,
        6
      )} ${phoneNumber.substring(6, 9)} ${phoneNumber.substring(9)}`
    : ''
}
